module.exports = __webpack_public_path__ + "media/src/images/logos/twitter-24e1ced94e108147f5fd595c11c4db42.png";